import { FC, useEffect, useState } from 'react'
import Select from 'react-select'
import { Admin } from '../../API'
import { AdminService } from '../services/AdminService'
import './select.scss'

interface AdminSelectProps {
  defaultValue?: string | null
  onChange: Function
}
const AdminSelect: FC<AdminSelectProps> = ({ defaultValue, onChange }) => {
  const [options, setOptions] = useState()
  const [items, setItems] = useState<Admin[]>([])
  const [selectedOption, setSelectedOption] = useState(defaultValue)

  const handleChange = (value: any) => {
    setSelectedOption(value)
    onChange(items.find((itm: Admin) => itm.id === value.value))
  }

  const fetchOptions = async () => {
    const res: any = await AdminService.Instance.list()
    if (res.data) {
      setItems(res.data)
      setOptions(
        res.data?.flatMap((itm: Admin) => {
          return { value: itm.id, label: `${itm.name}` }
        }),
      )
    }
  }

  useEffect(() => {
    fetchOptions()
  }, []) // eslint-disable-line

  return <Select value={selectedOption} options={options} onChange={handleChange} className='tbn-select' />
}

export default AdminSelect
